<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <h2 class="members__headline">フレンド情報</h2>
      <!-- {{ getMyGuests }} -->


      <div class="members-member-form">
        <div class="members-member-form__wrapper">
          <div class="row gx-15 members-member-form__group">
            <div class="col-12">
              <div class="members-member-form__data">
                <input type="text" v-model="tmp_search_words" placeholder="お名前等">
              </div>
            </div>
            <div class="col-12 py-3">
              <p class="reserveRunSearch__search">
                  <button class="button02 button02--gray reserveRunSearch__searchButton" @click="friendSearch">検索</button>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="members-guest" v-if="Object.keys(tmp_search_list).length > 0">
          <div class="members-guest__wrapper" >
            <h3 class="members-guest__headline">会員一覧</h3>
            <div class="members-guest__card d-flex">
              <div class=" mb-2">
                  <div v-for="mem in tmp_search_list" :key="mem">
                      <p class="text-center">
                          <a class="reserve05__addMemberLink" @click="addFriend(mem)">＋ {{ mem.true_name_label }}</a>
                      </p>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div class="members-guest">
        <div  v-if="Object.keys(friends).length > 0">
          <div class="members-guest__wrapper" v-for="(friend, index) in friends" :key="friend">
            <h3 class="members-guest__headline">フレンド会員{{ (index + 1) }}</h3>
            <div class="members-guest__card d-flex">
              <ul class="members-guest__list">
                <li class="d-flex align-items-center">
                  <soan class="item">name</soan><span class="name">{{ friend.friend_label }} 様</span>
                </li>
              </ul>
              <p class="members-guest__btn"><a class="button" @click="delFriend(index)">削除</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import config from '../../../const'
import { mapState } from 'vuex'
import axios from 'axios'
import Common from '../../../common/common'


export default {
  name: 'UserFriendView',
  data: function () {
      return {
        tmp_search_words: '',
        tmp_search_list: [],
        max: 5,
        friends: [],
      }
  },
  components: {
  },
  methods: {
    friendSearch(){
      if(this.tmp_search_words.length <= 0){
          alert('検索ワードを入力して下さい');
          return;
      }

      const params = {};
      // params['stat'] = [1];
      params['search_words'] = this.tmp_search_words;
      const params_ = Common.createParams(params);
      axios.post(
          config.BASE_API_URL + '/member/lists',
          params_,
          {
          headers: this.axiosHeader
          }
      )
      .then(
          (response) => {
              this.tmp_search_list = response.data.body;
              console.log('then friendSearch', response);
          // if(this.dashboard.drive_node) this.drive_node = this.dashboard.drive_node;
          }
      )
      .catch((err) => {
          console.log(err);
          // this.search_sales = [];
      })
      .finally(() => {
          console.log('finally friendSearch');
          this.$forceUpdate();
      });
    },

    delFriend(target){
      const tmp = [...this.friends];
      console.log('delGuest tmp =', tmp);
      tmp.splice(target, 1);
      console.log('delGuest tmp.splice =', tmp);
      this.friends = tmp;
      console.log('delGuest guestFrm =', this.friends);
      this.update();
    },
    addFriend(member){
      const tmp = [...this.friends];
      console.log('delGuest tmp =', tmp);
      const add = {
        'friend_id': member.id,
        'key': member.id,
        'label': (member.true_name_label)? member.true_name_label: '',
        'friend_label': (member.true_name_label)? member.true_name_label: '',
        'kbn_id': 0
      }
      if(member.kbn && member.kbn.kbn_id) add.kbn_id = member.kbn.kbn_id;
      tmp.push(add);
      this.friends = tmp;
      this.tmp_search_list = [];
      this.update();
    },
    update(){
      // alert('登録しました-demo-');
      const mydata = this.getMyData;
      mydata['friendship_data'] = this.friends;
      console.log('component methods', mydata);
      return this.$store.dispatch('updateBasic', {data: mydata, target: 'member' })
          .then(() => {
            // // this.back()
            alert('更新しました');
            // this.alertMessage = this.btnLabel + 'しました';
            // this.alertClass = 'alert-success';
          })
          .catch(
            () => {
            err => Promise.reject(err);
            alert('更新できませんでした');
              // this.alertMessage = this.btnLabel + 'できませんでした';
              // this.alertClass = 'alert-danger';
            }
          )
    },
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});
    },
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
    }),
    getMyFriends: function(){
      if(this.getMyData.friendship){
        return this.getMyData.friendship;
      }
      return [];
    },
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
  },
  created () {
    this.loadUser();
    this.friends = this.getMyFriends;
  },
  mounted: function(){
  },

  props: {
  }

}
</script>
